import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Box } from "@mui/system";
import CropRotateIcon from "@mui/icons-material/CropRotate";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import { useMediaQuery } from "@mui/material";
import Investtab from "./Investtab";
import { FormControlLabel } from "@mui/material";
import { Row, Col } from "reactstrap";


import {
  Container,
  FormControl,
  Input,
  InputAdornment,
  InputBase,
  InputLabel,
  Paper,
  TextField,
  Typography,
  Button,
} from "@mui/material";

import IconButton from "@mui/material/IconButton";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
// Nested List starts
import ListItemButton from "@mui/material/ListItemButton";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import List from "@mui/material/List";
import { Link, NavLink } from "react-router-dom";
// Nested List ends
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { AiOutlineCalculator } from "react-icons/ai";



import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { setGeneralset } from "../../../redux/actions/adminDash_action.js";
import API from "./../../../redux/url.js";
import axios from "axios";

const Generalsettings = () => {

  const dispatch = useDispatch();

const [general, setgeneral] = useState(false);

  const [state, setState] = useState({
    name: "",
    email: "",
    copyright: "",
    image: null,
  });

    const SiteGeneralupdate = useSelector(
      (state) => state.adminDashboard_red.SiteGeneralupdate
    );

    console.log("SiteGeneralupdate");
    console.log(SiteGeneralupdate);


useEffect(() => {
  // dispatch(getsocial());
  axios.get(API + "/getGeneralsett").then((res) => {
    console.log("getGeneralsett.data", res.data);
    setgeneral(res.data);
    console.log("getGeneralsett.data", res.data[0].name);

    setState({
      name: res.data[0].name,
      email: res.data[0].email,
      copyright: res.data[0].copyright,
    });
  });
}, [SiteGeneralupdate]);
  

console.log("state.name after useEffect");
console.log(state.name);

  

   const [statement, setStatement] = React.useState(false);
   const handleClickStatement = () => {
     setStatement(!statement);
   };

   const labls = {
     color: '#101924',
     flex: '1',
     marginLeft: '2px'
   };

const errmsg = {
  color: "red",
  position: "relative",
  top: "-11px",
};

const inputstyle = {
      padding: "3px 4px",
                display: "flex",
                alignItems: "center",
                width: "100%",
                border: "1px solid #bec2c7",
                borderRadius: "7px",
                marginBottom: "20px",
}



  const check = useMediaQuery("(max-Width:900px)");



  const [nameerr, setnameerr] = useState("");
  const [emailerr, setemailerr] = useState("");
  const [copyrighterr, setcopyrighterr] = useState("");


   const onChangeHandler = (e) => {
     if (e.target.name == "image") {
       let val = e.target.files[0];
       setState({ ...state, [e.target.name]: val });
      
     } else {
       setState({ ...state, [e.target.name]: e.target.value });
     }
      console.log(state);
   };





   
  const validate = () => {
    const re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const isemailVer = re.test(state.email);
    console.log("isemailVer", isemailVer);

    let isvalid = true;

    if (
      state.name.length < 3 ||
      state.name.length > 20 ||
      state.name.length == 0
    ) {
      isvalid = false;
      setnameerr("Username needs to be 3 to 20 characters long");
      setemailerr("");
      setcopyrighterr("");
    } else if (!isemailVer) {
      isvalid = false;
      setemailerr("Your Email is not Correct!");
      setcopyrighterr("");
      setnameerr("");
    } else if (
      state.copyright.length < 5 ||
      state.copyright.length > 55 ||
      state.copyright.length == 0
    ) {
      isvalid = false;
      setcopyrighterr("copyright needs to be 55 to 30 characters long");
      setemailerr("");
      setnameerr("");
    } else {
      setnameerr("");
      setemailerr("");
      setcopyrighterr("");
    }

    return isvalid;
  };




  const SubmitData = (e) => {
    e.preventDefault();

    let obj = {
      ...state,
      // description,
      // checkbox,
    };

    var isFormvalid = validate();
    console.log("isvalid", isFormvalid);
    window.scrollTo(0, 200);
    if (isFormvalid) {
      console.log(obj);
      dispatch(setGeneralset(obj));
      // alert("ok");
    }

    // setState("");

    //  inputRef.current.focus();
  };

  return (
    <div className="content-wrapper">
      <div
        id="order_preview"
        className="wow fadeInUp content_box"
        style={{ visibility: "visible", animationName: "fadeInUp" }}
      >
        <Row classNameName="table-header">
          <Col xs="12" md="12">
            <h2 className="section-title" style={{ color: "black" }}>
              Edit Gerneral Settings{" "}
            </h2>
          </Col>
        </Row>
        <div className="row">
          <Row>
            <Col xs="12" md="9">
              {general ? (
                <div>
                  {general.map((item, index) => {
                    return (
                      <form>
                        <div className="form-group">
                          <label for="pwd">Change Your Site Title</label>
                          <input
                            type="text"
                            className="form-control"
                            required
                            name="title"
                            onChange={onChangeHandler}
                            defaultValue={state.name}
                          />
                          <center>
                            {nameerr ? (
                              <div style={errmsg}>{nameerr}</div>
                            ) : null}
                          </center>
                        </div>

                        <div className="form-group">
                          <label for="pwd">Change Your Site email</label>

                          <input
                            type="text"
                            className="form-control"
                            required
                            name="email"
                            onChange={onChangeHandler}
                            defaultValue={state.email}
                          />
                          <center>
                            {emailerr ? (
                              <div style={errmsg}>{emailerr}</div>
                            ) : null}
                          </center>
                        </div>

                        <div className="form-group">
                          <label for="pwd">Change Your Site copyright</label>

                          <input
                            type="text"
                            className="form-control"
                            required
                            name="copyright"
                            onChange={onChangeHandler}
                            defaultValue={state.copyright}
                          />
                          <center>
                            {copyrighterr ? (
                              <div style={errmsg}>{copyrighterr}</div>
                            ) : null}
                          </center>
                        </div>

                        <div className="form-group">
                          <label for="pwd">Upload Your Site Logo </label>

                          <img
                            src={API + "/uploads/" + item.image}
                            alt={item.image}
                            height="100"
                            width="100"
                          />
                          <input
                            type="file"
                            className="form-control"
                            name="image"
                            onChange={onChangeHandler}
                            required
                          />
                        </div>

                        {/* <div className="form-group featuredItems_out">
                    <input
                      type="checkbox"
                      className=""
                      required
                      name="isFeatured"
                      id="featured_item"
                      onChange={onChangeHandler}
                    />
                    <label for="featured_item">Featured</label>
                  </div> */}
                        <button
                          type="submit"
                          className="btn btn-default"
                          onClick={SubmitData}
                          style={{
                            marginTop: 10,
                            float: "right",
                            padding: "8px 16px",
                            fontSize: 16,
                          }}
                        >
                          Update Now
                        </button>
                      </form>
                    );
                  })}
                </div>
              ) : (
                <div>Loading...</div>
              )}
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Generalsettings;
